import { createContext } from "react"

export type PdfViewerContextType = {
  pdf: Blob | null
  setPdf: React.Dispatch<React.SetStateAction<Blob | null>>
}

export const PdfViewerContext = createContext<PdfViewerContextType>(null!)
